import "./polyfills";
import * as Pages from "./pages";

//Pages object
Object.keys(Pages).forEach((key) => Pages[key]());
